import React from 'react'
import PropTypes from 'prop-types'
import cs from 'classnames'

import './Button.scss'

const Button = ({
    children,
    kind,
    gtmCategory,
    gtmAction,
    gtmLabel,
    onClick,
    className,
    ...otherProps
}) => (
    <button
        onClick={onClick}
        {...otherProps}
        className={cs('button', kind ? `button--${kind}` : null, className)}
        data-gtm-event-category={gtmCategory}
        data-gtm-event-action={gtmAction}
        data-gtm-event-label={gtmLabel}
    >
        {children}
    </button>
)

Button.defaultProps = {
    onClick: () => {}
}

Button.propTypes = {
    type: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired
}

export default Button
